<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='58'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 大会议程管理页面
 */
import {mapState} from 'vuex'
import ProcessAdd from '../../../../static/form/ProcessAdd.vue'
import ProcessLB from '../assembly/ProcessLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
export default {
  components: {
    ProcessAdd,
    ProcessLB,
    ComboBox
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '大会议程列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: ProcessLB
      }],
      addobj: {
        title: '添加大会议程',
        name: '3',
        closable: true,
        content: ProcessAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Processgl.vue